import React from 'react'


import { makeStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import userUtils from 'utils/user'

import Icon from './Icon'

const useStyles = makeStyles(theme => ({
  avatarWrapper: {
    display: 'flex',
  },
  avatarName: {
    flex: 1,
    margin: theme.spacing(),
    textTransform: ['none', '!important'],
  },
}))

const Avatar = ({
  user,
  noName,
  noIcon,
  iconAlign,
}) => {
  const classes = useStyles()

  const name = user && !noName ? (
    <Typography 
      variant="body1" 
      color="inherit" 
      className={ classes.avatarName }
    >
      { userUtils.getDisplayName(user) }
    </Typography>
  ) : null

  const icon = noIcon ? null : (
    <Icon 
      user={ user }
    />
  )

  if(iconAlign == 'left') {
    return (
      <div className={ classes.avatarWrapper }>
        { icon }
        { name }
      </div>
    )
  }
  else {
    return (
      <div className={ classes.avatarWrapper }>
        { name }
        { icon }
      </div>
    )
  }    
}

export default Avatar